import { ApiClient } from './client.js'
import { SUBSCRIPTIONS } from './resources.js'

const client = new ApiClient()

export default {
  retrieve (subscriptionId) {
    return client.get(`${SUBSCRIPTIONS}${subscriptionId}/`)
  },

  retrieveCurrent () {
    return client.get(`${SUBSCRIPTIONS}current/`)
  },

  list () {
    return client.get(`${SUBSCRIPTIONS}`)
  },

  listAll () {
    return client.getAll(`${SUBSCRIPTIONS}`)
  },

  create (data) {
    return client.post(`${SUBSCRIPTIONS}`, data)
  },

  cancel (subscriptionId) {
    return client.post(`${SUBSCRIPTIONS}${subscriptionId}/cancel/`)
  },

  reactivate (subscriptionId) {
    return client.post(`${SUBSCRIPTIONS}${subscriptionId}/reactivate/`)
  },

  activate (subscriptionId, data) {
    return client.post(`${SUBSCRIPTIONS}${subscriptionId}/activate/`, data)
  },

  upcoming (data) {
    return client.post(`${SUBSCRIPTIONS}upcoming/`, data)
  }
}
